import { Injectable } from '@angular/core';
import { ToolsControlService } from './tools-control.service';

@Injectable({
  providedIn: 'root'
})
export class BarometricToolService {

  active : boolean;
  fullScreenMode : boolean = false;

  constructor(
    private toolsService: ToolsControlService,
  ) { }

  openWindow():void {
    this.active = true;
    this.toolsService.navigationOnTop = true;
  }
}
